/**
 * 灵感推荐词组件
 *
 * @module components/InspirationRecommendWords
 */

import { TrackerDiv } from "@/components/Tracker";
import type { WordMetadata } from "@/types/inspirationWords";
import React from "react";
import styles from "./index.module.less";

export interface InspirationRecommendWordsProps {
  /** 推荐词元数据列表 */
  words: WordMetadata[];
  /** 关联的文件ID（内容的唯一标识） */
  relatedFileId: string;
  /** 模块在瀑布流中的位置 */
  moduleLocation: number;
  /** 触发类型（共现触发 / 累计触发） */
  triggerType: string;
  /** 来源的 file_ids 列表（逗号分隔） */
  sourceFileIds: string;
  /** 样式对象 */
  style?: React.CSSProperties;
}

/**
 * 灵感推荐词组件
 */
export const InspirationRecommendWords: React.FC<InspirationRecommendWordsProps> =
  React.memo(
    ({
      words,
      relatedFileId,
      moduleLocation,
      triggerType,
      sourceFileIds,
      style,
    }) => {
      const handleWordClick = (wordMeta: WordMetadata) => {
        // 构建搜索 URL（包含 search_word_type 参数）
        const searchUrl = `/search?q=${encodeURIComponent(
          wordMeta.word
        )}&type=pin&search_word_type=${encodeURIComponent("灵感推荐词")}`;

        // 新标签页打开
        window.open(searchUrl, "_blank");
      };

      if (!words || words.length === 0) {
        return null;
      }

      return (
        <div className={styles.container} style={style}>
          <div className={styles.title}>你可能感兴趣的灵感</div>

          <div className={styles.wordsList}>
            {words.map((wordMeta, index) => (
              <TrackerDiv
                key={index}
                className={styles.wordItem}
                onClick={() => handleWordClick(wordMeta)}
                data-gd-expose="resource_loc_expose"
                data-gd-click="resource_loc_click"
                data-module-name="灵感推荐词"
                data-module-location={moduleLocation}
                data-subject-name="搜索词资源位"
                data-resource-title={wordMeta.word}
                data-resource-location={index + 1}
                data-resource-type={triggerType}
                data-word-dist-code={wordMeta.distCode}
                data-source-file-ids={sourceFileIds}
              >
                {wordMeta.word}
              </TrackerDiv>
            ))}
          </div>
        </div>
      );
    }
  );

InspirationRecommendWords.displayName = "InspirationRecommendWords";
